/**
 * TOGGLES: A class that toggles toggleable elements with a toggleclass
 *
 * Put two arguments on the element that triggers the toggle:
 * - data-toggles = Target that will be toggled
 * - data-toggles-class = Class that will be appended, defaults to 'is--visible'
 *
 */

import Toggles from 'scripts/modules/toggles';

/**
 * Attach listeners to document
 */
$(() => {
    /**
     * Travel through the DOM for data-at-modal attributes
     * For each of the founded data attr create a new modal
     */
    $('[data-toggles]').each(Toggles.prototype._attach);

    /**
     * Setup a jQuery chainable plugin for attaching to injected elements after page load
     * @type {*}
     */
    $.fn.AtToggles = function () {
        $(this).each(Toggles.prototype._attach);
    };
});
